import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import { fetchAPI, getStrapiMedia } from "../../utils/api";

const PortfolioSingleSection = () => {
  const { slug } = useParams(); // Using slug to capture the ID from the route /work/:slug
  const [portfolio, setPortfolio] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const getData = async () => {
      if (!slug) return;
      try {
        const work = await fetchAPI(`/works/${slug}`, {
          populate: ['image', 'categories']
        });

        if (work.data) {
          const item = work.data;
          setPortfolio({
            title: item.title,
            description: item.description,
            categories: item.categories ? item.categories.map(c => c.name) : [],
            gallery: item.image ? (Array.isArray(item.image) ? item.image : [item.image]).map(img => getStrapiMedia(img)) : []
          });
        }
      } catch (error) {
        console.error("Error fetching portfolio data:", error);
      } finally {
        setLoading(false);
      }
    };
    getData();
  }, [slug]);

  if (loading) return <div>Loading...</div>;
  if (!portfolio) return <div>Project not found.</div>;

  return (
    <section className="content">
      <div className="container">
        <div className="row justify-content-between">
          <div className="col-12 col-lg-5">
            <div className="heading">
              <div className="portfolio-meta d-flex align-items-center">
                <div className="portfolio-terms">
                  {portfolio.categories.map((category, index) => (
                    <a key={index} className="terms" href="/portfolio">
                      {category}
                    </a>
                  ))}
                </div>
              </div>
              <h2>{portfolio.title}</h2>
              <div dangerouslySetInnerHTML={{ __html: portfolio.description }} />
            </div>
          </div>
          <div className="col-12 col-lg-6 items portfolio-meta mt-3 mt-md-0">
            {/* 
                Strapi 'works' endpoint does not currently support:
                - Task
                - Role/Services
                - Client
                - Category & Year
                - Live Site link
                
                I am hiding these sections to avoiding showing broken/empty data. 
                If these fields are added to Strapi later, they can be re-enabled.
             */}
          </div>
        </div>
        <div className="row portfolio-content items">
          <div className="col-12">
            {/* Gallery */}
            {portfolio.gallery.map((img, index) => (
              <div key={index} className="item">
                <img src={img} alt={`Gallery ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PortfolioSingleSection;

